import { Controller } from "@hotwired/stimulus"

// Each Profile card saves its own fields, with actions beside the edit.
export default class extends Controller {
    static targets = ["display", "form", "actions", "edit", "status"]

    connect() {
        if (this.element.dataset.profileSectionEditing === "true") this.open(false)
    }

    toggle(event) {
        event.preventDefault()
        this.open(true)
    }

    open(focus) {
        this.formTarget.classList.remove("d-none")
        this.displayTarget.classList.add("d-none")
        this.actionsTarget.classList.remove("d-none")
        this.editTarget.classList.add("d-none")
        this.editTarget.setAttribute("aria-expanded", "true")
        if (focus) this.formTarget.querySelector("input:not([type=hidden]), textarea, select")?.focus()
    }

    async save(event) {
        event.preventDefault()
        if (this.saving) return
        this.saving = true
        const button = this.element.querySelector('[type="submit"]')
        button.disabled = true
        this.statusTarget.textContent = "Saving…"
        try {
            const response = await fetch(this.element.action, {
                method: "POST", body: new FormData(this.element),
                headers: { Accept: "text/html", "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "" }
            })
            const html = new DOMParser().parseFromString(await response.text(), "text/html")
            const updated = html.getElementById(this.element.id)
            if (!updated || (!response.ok && response.status !== 422)) throw new Error("Save failed")
            if (response.ok) updated.querySelector('[role="status"]').textContent = "Saved"
            this.element.replaceWith(updated)
        } catch (_error) {
            this.statusTarget.textContent = "Couldn't save. Try again."
            button.disabled = false
            this.saving = false
        }
    }

    cancel(event) {
        // After a server validation error, reload the saved values.
        if (this.element.dataset.profileSectionEditing === "true") return
        event.preventDefault()
        this.element.reset()
        this.formTarget.classList.add("d-none")
        this.displayTarget.classList.remove("d-none")
        this.actionsTarget.classList.add("d-none")
        this.editTarget.classList.remove("d-none")
        this.editTarget.setAttribute("aria-expanded", "false")
        this.editTarget.focus()
    }
}
